module.exports = __webpack_public_path__ + "static/media/whatsapp.3238aee5.svg";